define('SageDotCom/Components/Content/ProductTour/ProductTourFeatures',["jquery"],
    function($) {

        function ProductTourFeatures(scope) {
            function init() {

                var benefitsVideoSm = $(scope).find('.pt-benefits-sm')[0];
                var benefitsVideoMd = $(scope).find('.pt-benefits-md')[0];
                var $controls = $(scope).find('.controls');
                var $playHolder = $controls.find('.play-holder');
                var initialising = true;

                var playVideo = function (video) {
                    var promise = video.play();

                    if (promise !== null && promise !== undefined) {
                        promise.then(function() {
                                video.muted = false;
                            },
                            function(reason) {
                                video.muted = true;
                                video.play();
                            });
                    }
                };

                var featuresFocus = function () {
                    var sectionOffset = $(scope).parents(".product-tour-section.benefits").offset().top;

                    if (sectionOffset > window.pageYOffset) {
                        window.scrollTo({
                            top: sectionOffset,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                };

                var adjustVideoSrcs = function(href)
                {
                    $(benefitsVideoSm).find("video").attr("src", href);
                    $(benefitsVideoMd).find("video").attr("src", href);
                }

                var videoClickHandler = function (e) {
                    var $target = $(e.target);
                    var $targetHolder = $target.parents('.holder');
                    var href = e.target.href;
                    var offset = $target.offset().top - $controls.offset().top + 40;
                    var targetVideoWrapper = $(benefitsVideoSm).is(':visible') ? benefitsVideoSm : benefitsVideoMd;
                    var targetVideo = $(targetVideoWrapper).find('video')[0];

                    e.preventDefault();

                    e.isProgramatic !== true && featuresFocus();

                    adjustVideoSrcs(href);
                    playVideo(targetVideo);

                    $playHolder.height(offset);
                    $playHolder.addClass('is-linked');

                    $controls.find('.holder').removeClass('is-controlled');
                    $targetHolder.addClass('is-controlled');

                    return false;
                };

                var controlClickHandler = function (e) {
                    var $target = $(e.target);
                    var $targetHolder = $target.siblings('.holder');
                    var height = $targetHolder.find('ul').innerHeight();

                    e.preventDefault();

                    e.isProgramatic !== true && featuresFocus();

                    $controls.find('.holder').css({ maxHeight: 0 });
                    $controls.find('.holder a').attr('tabindex', '-1');
                    $controls.find('.video-accordion button').attr('aria-expanded', 'false');

                    $targetHolder.css({ maxHeight: height });
                    $targetHolder.find('a').attr('tabindex', '0');
                    $target.attr('aria-expanded', 'true');

                    $playHolder.toggleClass('is-linked', $targetHolder.hasClass('is-controlled'));

                    var firstVideoHref = $targetHolder.find('a')[0];

                    // use this to trigger the first video while opening the accordian section
                    e.isProgramatic !== true && setTimeout(function () {
                        videoClickHandler({ target: firstVideoHref, preventDefault: function () { }, isProgramatic: true });
                    }, 400);

                    //On initialisation, make sure the src of the video elements is the first item in the accordion
                    initialising = false;
                    if (firstVideoHref) {
                        adjustVideoSrcs(firstVideoHref.href);
                    }
                    return false;
                };

                $controls.find('.video-accordion .trigger').on("click", controlClickHandler);
                $controls.find('.video-accordion .video-link').on("click", videoClickHandler);

                $controls.find('.holder').first().addClass('is-controlled');
                controlClickHandler({
                    target: $controls.find('.video-accordion .trigger')[0],
                    preventDefault: function() {},
                    isProgramatic: true
                });
            };

            init();
        };

        return function initProductTourFeatures(args) {
            return args.IsExperienceEditorEditing === false ? new ProductTourFeatures(args.scope) : null;
        };
    });
